dynamicSref.$inject = ['$state'];
export function dynamicSref($state) {
    return {
        restrict: 'A',
        scope: {
            state: '=dynamicSref',
            params: '=?dynamicSrefParams'
        },
        link: function ($scope, $element, attr) {
            var updateHref = function () {
                if ($scope.state) {
                    var href = $state.href($scope.state, $scope.params);
                    $element.attr('href', href);
                }
            };

            $scope.$watch('state',  (newValue, oldValue) => {
                if (newValue !== oldValue) {
                    updateHref();
                }
            });

            $scope.$watch('params', function (newValue, oldValue) {
                if (newValue !== oldValue) {
                    updateHref();
                }
            });

            updateHref();
        }
    };
}
module.exports = dynamicSref;



// WEBPACK FOOTER //
// ./src/utils/dynamic-sref.js